import { errorMessage } from "../workspace/format";
import { passkeySignInLabel, type PasskeyPlatform } from "./passkeyPlatform";

function passwordRecoveryMessage(platform: PasskeyPlatform): string {
  const savedPasswordSource = platform === "apple" ? "Apple" : "your browser";
  if (platform === "windows") {
    return "That Yodl password was not accepted. If Apple Passwords or your browser filled it, the saved password may be old. Tap “Forgot password?” If several tries failed, wait a few minutes before trying again. After the password is accepted, Yodl shows Windows Hello, phone QR, email code, and passkey-manager options.";
  }
  return `That Yodl password was not accepted. If ${savedPasswordSource} filled it, the saved password may be old. To use your passkey, tap “${passkeySignInLabel(platform)}” below. Otherwise tap “Forgot password?” If several tries failed, wait a few minutes before trying again.`;
}

export function passwordSignInError(error: unknown, platform: PasskeyPlatform = "other"): string {
  const message = errorMessage(error);
  if (/network|failed to fetch|offline|connection/i.test(message)) {
    return "Yodl could not reach the sign-in service. Check the internet connection and try again.";
  }
  // Convex intentionally redacts production action errors, so InvalidSecret
  // reaches the browser as a generic auth:signIn Server Error. Password sign-in
  // must never expose that internal error or imply that the whole app is down.
  return passwordRecoveryMessage(platform);
}
